export default __webpack_public_path__ + "static/media/46t.f408ee43.jpg";